<template>
	<div>
		<div class="dingdan">
			<el-breadcrumb separator-class="el-icon-arrow-right">
			  <el-breadcrumb-item :to="{ path: '/demandHome/demandOrder' }">我的订单</el-breadcrumb-item>
			  <el-breadcrumb-item>订单详情</el-breadcrumb-item>
			  <el-breadcrumb-item>发起评审</el-breadcrumb-item>
			</el-breadcrumb>
			<div class="fh_button" @click="fanhui" style="cursor:pointer;">
				<i class="el-icon-arrow-left"></i>
				<p>返回</p>
			</div>
		</div>
		<div class="dibox">
			<uni-section title="评审材料" type="line"></uni-section>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
				<el-form-item label="详情描述" prop="content">
					<el-input type="textarea" v-model="ruleForm.content" placeholder="请根据实际情况填写您的说明内容"></el-input>
				</el-form-item>
				<el-form-item label="附件上传" prop="file">
					<el-upload
					  class="upload-demo"
					  :action="uploadActionUrl"
					  :on-remove="handleRemove"
					  :on-success="handleUploadSuccess"
					  :before-remove="beforeRemove"
					  :multiple='false'
					  :limit="4"
					  :on-exceed="handleExceed"
					  :file-list="fileList">
						 <div>
							<el-button size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
							<span style="margin-left:10px;font-size: 12px;color: #FF0000;">
								单个文件最大支持10M，最多不超过四个文件。仅支持png，jpg，pdf文件类型
							</span>
						 </div>
					</el-upload> 
				</el-form-item>
				<el-form-item label="评审金额">
					<span style="font-size:24px;color:#FF5900;">{{Price.totalReviewPrice}}元</span>
					<p style="font-size: 14px;color: #FF0000;">
						  败方和未评审人的评审金将原路退回。如果多次发起评审并且修改内容，将会以最新一次的表单记录进行提交</p>
				</el-form-item>
				
			</el-form>
			<div class="ruleFooter">
				<div class="ruleFooter1" @click="quxiao">取消</div>
				<div class="ruleFooter2" @click="submitForm('ruleForm')">立即提交</div>
			</div>
		</div>
		<el-dialog
		  title="支付方式"
		  :visible.sync="payDialogVisible"
		  :close-on-click-modal="false"
		  width="750px"
		  >
<!-- 		  <div>
			  <div class="pay-tip"><h3>扫码支付</h3><span>打开手机端微信APP扫一扫支付</span></div>
			  <div class="pay-box">
				  <LinkQrCode :link="payLink" :size="120" />
				  <div class="pay-box1">
					  <div class="pay-box2">
						  <h4>支付金额</h4>
						  <span>￥{{Price.totalReviewPrice}}</span>
					  </div>
				  </div>
			  </div>
		  </div> -->
		  <div>
			  <div class="pay-box">
				  <LinkQrCode :link="payLink" :size="120" />
				  <div class="pay-box1">
					  <div class="pay-tip"><h3>扫码支付</h3><span>打开手机端微信APP扫一扫支付</span></div>
					  <h4 style="width:100%;">支付金额</h4>
				        <div class="pay-box2" style="width:100%;">
						  <div class="pay-box3">
							  <span>￥{{Price.totalReviewPrice}}</span>
							  <div class="pay-box4">
								  <img src="@/assets/wxpay.png" alt="" />
								  <p>微信支付</p>
							  </div>
						  </div>
					  </div>
				  </div>
			  </div>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import config from '@/config/index'
	import LinkQrCode from '@/common/LinkQrCode.vue'
	import {OrderReviewApply,
		OrderReviewPay,
		priceosId,
		payStatus} from "@/api/api"
import { setInterval } from 'core-js'
	export default {
	  name: 'HelloWorld',
	  components:{
		 LinkQrCode
	  },
	  data() {
	    return {
		   baseURL:config.baseURL,
		   ruleForm:{
			   content:"",
			   file:[],
		   },
		    rules: {
				 content: [
				   { required: true, message: '请输入详情描述', trigger: 'blur' },
				 ],
				  file:[
				   { required: true, message: '附件不能为空', trigger: 'blur' },
				 ],
			},
			fileList:[],
			ruleFormimglist:[],
			Price:"",
			payDialogVisible:false,
			order:"",
			paybox:"",
			payLink:"",
			payTimer:null
	    }
	  },
	  watch: {
	  	payDialogVisible(val) {
	  		if (!val) this.clearPayTimer()
	  	}
	  },
	  beforeDestroy() {
	  	this.clearPayTimer()
	  },
	  computed: {
			...mapState({
				user: (state) => state.userInfo || {}
			}),
	  		isPersonalCenterActive() {
	  		  const p = this.$route && this.$route.path ? this.$route.path : ''
	  		  return /^\/demandHome\/(demandinvoiceList|demandUserInfo|demandPromotion)(\/|$)/.test(p)
	  		},
			uploadActionUrl() {
				const base = this.baseURL || ''
				console.log(base)
				const path = (base.endsWith('/') ? '' : '/') + 'Upload/upload'
				return base + path
			},
			type(){
				return this.$route.query.type || ''
			},
			os_id() {
				return this.$route.query.os_id || ''
			}
	  },
	  created() {
	  	this.getpriceosId()
		this.userinfo()
	  },
	  methods: {
		  userinfo(){
		      return this.$store.dispatch('fetchPersonal').then(() => {
		      
		  	})
		  },
		  fanhui(){
			 this.$router.go(-1);   
		  },
		  quxiao(){
			 this.$router.go(-1); 
		  },
		  handleExceed(files, fileList) {
		    this.$message.warning(`最多上传 4 个文件，当前已选 ${fileList.length} 个，本次选择了 ${files.length} 个，请勿超出限制`)
		  }, 
		  beforeRemove(file) {
		    return this.$confirm(`确定移除 ${file.name}？`)
		  },
		  handleRemove(file, fileList) {
		    this.fileList = this.normalizeUploadFileList(fileList)
		    const removedUrl = this.getUploadUrlFromResponse(file.response) || file.url || ''
		    if (!removedUrl) return
		    this.ruleForm.file = this.ruleForm.file.filter((url) => url !== removedUrl)
		  },
		  handleUploadSuccess(response, file, fileList) {
			  console.log(response, file, fileList)
		  	  this.fileList = this.normalizeUploadFileList(fileList)
			  const uploadedUrl = this.getUploadUrlFromResponse(response) || file.url || ''
			  if (uploadedUrl) {
					const exists = this.ruleForm.file.includes(uploadedUrl)
					if (!exists) this.ruleForm.file.push(uploadedUrl)
			  }
			  console.log(this.ruleForm)
		  },
		  normalizeUploadFileList(list) {
		  	const uidMap = {}
		  	return (list || []).map((item, index) => {
		  		const rawUid = item && item.uid !== undefined ? String(item.uid) : ''
		  		let uid = rawUid || `upload-${Date.now()}-${index}`
		  		if (uidMap[uid]) {
		  			uid = `${uid}-${uidMap[uid]}`
		  		}
		  		uidMap[uid] = (uidMap[uid] || 0) + 1
		  		return {
		  			...item,
		  			uid
		  		}
		  	})
		  },
		  submitForm(formName) {
			  this.$refs[formName].validate((valid) => {
				if (valid) {
				  this.tongguo()
				} else {
				  return false;
				}
			  });
		  },
		  getUploadUrlFromResponse(response) {
		    if (!response) return ''
		    if (typeof response === 'string') return response
		    const level1 = response.data || {}
		    const level2 = level1 && level1.data ? level1.data : {}
		    const candidate =
		  	level2.url ||
		  	level2.file ||
		  	(typeof level2 === 'string' ? level2 : '') ||
		  	level1.url ||
		  	level1.file ||
		  	(typeof level1 === 'string' ? level1 : '') ||
		  	response.url ||
		  	response.file ||
		  	(response.response && response.response.data) ||
		  	''
		    if (Array.isArray(candidate)) return candidate[0] || ''
		    if (typeof candidate === 'string') return candidate
		    if (Array.isArray(level1)) return level1[0] || ''
		    if (typeof level1 === 'string') return level1
		    return ''
		  },
		  tongguo(){
			  OrderReviewApply(this.os_id,{
			  	...this.ruleForm
			  }).then(res=>{
			      if(res.data.status==200){
			  		this.order=res.data.data
			  		this.getOrderPay()
			  	  }else{
					  // this.$message.error(res.data.msg)
				  }
			  })
		  },
		  getOrderPay(){
		  	OrderReviewPay({
		  		order_sn:this.order,
		  		pay_type:"NATIVE"
		  	}).then(res=>{
				if(res.data.status==200){
					const payLink = res.data.data.code_url
					if (!payLink) {
						this.$message.error('未获取到支付链接')
						return
					}
					this.payLink = payLink
					this.paybox = res.data.data || {}
					this.payDialogVisible = true
					this.setpayStatus()
				}else{
					// this.$message.error(res.data.msg)
				}
		  	})
		  },
		  clearPayTimer(){
		  	if (this.payTimer) {
		  		clearInterval(this.payTimer)
		  		this.payTimer = null
		  	}
		  },
		  // 支付轮询
		  setpayStatus(){
		  	this.clearPayTimer()
		  	this.payTimer = setInterval(() => {
		  		payStatus({
		  			order_sn:this.order,
		  			order_type:"2"
		  		}).then(res=>{
		  			if (this.isPaySuccess(res.data)) {
		  				this.$message.success('支付成功')
		  				this.payDialogVisible = false
		  				this.clearPayTimer()
						setTimeout(()=>{
							this.$router.go(-1);
						},2000)
						
		  				this.$emit('gengxin',"0")
		  			}
		  		})
		  	}, 2000)
		  },
		  isPaySuccess(res){
		  	console.log(res,"1")
		  	const data = res && res.data ? res.data : {}
		  	console.log(data,"2")
		  	const payload = data || {}
		  	console.log(payload,"3")
		  	return res.status === 200 && payload.paid === 1
		  },
		  getpriceosId(){
			  priceosId(this.os_id,{
			  	
			  }).then(res=>{
			  	this.Price=res.data.data
			  })
		  }
	  }
	}
</script>

<style scoped>
	.dingdan{
		width:1200px;
		margin:0 auto;
		padding:36px 0px;
		box-sizing: border-box;
		display:flex;
		justify-content:space-between;
		align-items: center;
	}
	.fh_button{
		width: 58px;
		height: 24px;
		line-height:24px;
		background: #1E3A8A;
		border-radius: 4px ;
		font-weight: 500;
		font-size: 12px;
		color: #FFFFFF;
		display:flex;
		align-items:center;
		justify-content:center;
	}
	.fh_button i{
		margin-right:5px;
	}
	.dibox{
		width:1200px;
		margin:0 auto;
		background: #FFFFFF;
		border-radius: 12px 12px 12px 12px;
		padding:20px;
		box-sizing: border-box;
	}
	.ruleFooter{
		width:100%;
		display:flex;
		justify-content:center;
		align-items:center;
	}
	.ruleFooter1{
		width: 112px;
		height: 40px;
		background:#DDE2EE;
		color:#1E3A8A;
		font-size: 16px;
		border-radius: 8px 8px 8px 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		margin:0px 10px;
		cursor:pointer;
	}
	.ruleFooter2{
		width: 112px;
		height: 40px;
		background: #1E3A8A;
		color:#fff;
		font-size: 16px;
		border-radius: 8px 8px 8px 8px;
		display:flex;
		justify-content:center;
		align-items: center;
		margin:0px 10px;
			cursor:pointer;
	}
	.pay-tip{
		text-align: left;
		color: #666;
		font-size: 14px;
		display:flex;
		align-items: center;

	}
	.pay-tip h3{
		font-weight: bold;
		font-size: 19rpx;
		color: #333333;
		margin-right:10px;
	}
	.pay-tip span{
		font-weight: 400;
		font-size: 13rpx;
		color: #666666;
	}
	.pay-box{
			width:100%;
			display:flex;
			margin-top:10px;
		}
		.pay-tip{
			display:flex;
			align-items: center;
		}
		.pay-tip h3{
			font-weight: bold;
			font-size: 20px;
			color: #333333;
			margin-right:12px;
		}
		.pay-tip span{
			font-weight: 400;
			font-size: 14px;
			color: #666666;
		}
		.pay-box1{
			margin-left:24px;
			display: flex;
			justify-content:space-between;
			align-items: center;
			flex-wrap: wrap;
		}
		.pay-box1 p{
			color: #FF5900;
		}
	/* 	.pay-box2{
			margin-top:30px;
		} */
		.pay-box2 h4{
			font-weight: bold;
			font-size: 14px;
			color: #333333;
		}
		.pay-box2 span{
			font-weight: 800;
			font-size: 24px;
			color: #FF5900;
		}
		.pay-box3{
			display:flex;
			align-items: center;
		}
		.pay-box4{
			width:146px;
			height:42px;
		    display:flex;
			align-items: center;
			justify-content: center;
			background: #FFFFFF;
			border-radius: 12px;
			border: 1px solid #4DC800;
			margin-left:30px;
		}
		.pay-box4 img{
			width:20px;
			height:18px;
			margin-right:10px;
		}
		.pay-box4 p{
			font-weight: 400;
			font-size: 16px;
			color: #333333;
		}
	
</style>